export default __webpack_public_path__ + "static/media/currThumb.c17bea41.png";